
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { getProxyType, getProStree } from '@/api/common/common'

@Component({
  name: 'grant-user-detail',
  components: {
    DictSelect
  }
})

export default class GrantUserDetail extends Vue {
  get isEdit () {
    return this.params.flag !== 'edit'
  }

  get settlementMethod () {
    return this.params.settlementMethod === 1 ? '电子结算' : this.params.settlementMethod === 2 ? '现金结算' : ''
  }

  get proType () {
    const temp: any[] = []
    this.params.lbUserProTypes && this.params.lbUserProTypes.map((v: any) => {
      v.proTypeName && temp.push(v.proTypeName)
    })
    return temp.length === 0 ? '' : temp.join(',')
  }

  private presenterIdData: any[] = []

  private proTypeData: any[] = []

  private proTypeTemp:any = []

  private validatePhone (rule: any, value: any, callback: Function) {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (!reg.test(value)) {
      callback(new Error('请输入合法的联系电话'))
    } else {
      callback()
    }
  }

  private rules = {
    userAccount: [
      { required: true, message: '请输入登录账号', trigger: 'change' }
    ],
    userName: [
      { required: true, message: '请输入用户名称', trigger: 'change' }
    ],
    phone: [
      { validator: this.validatePhone, required: true, message: '请输入联系电话', trigger: 'change' }
    ],
    // wechat: [
    //   { required: true, message: '请输入微信号', trigger: 'change' }
    // ],
    proType: [
      { required: true, message: '请选择代理类型', trigger: 'change' }
    ],
    settlementMethod: [
      { required: true, message: '请输入结算方式', trigger: 'change' }
    ],
    deadline: [
      { required: true, message: '请选择日期', trigger: 'change' }
    ],
    state: [
      { required: true, message: '请选择是否启用', trigger: 'change' }
    ],
    scanStatus: [
      { required: true, message: '请选择是否启用', trigger: 'change' }
    ]
  }

  @Prop({ type: Object })
  private params!: object|any

  private elecBlock = {
    // eslint-disable-next-line eqeqeq
    hidden: this.params.settlementMethod == 1 ? !0 : !1,
    'elec-block': !0
  }

  @Watch('params.settlementMethod', { immediate: !0 })
  private settlementMethodChange (val: any) {
    if (val === 1) {
      this.elecBlock.hidden = !1
    } else {
      this.elecBlock.hidden = !0
    }
  }

  @Watch('params.proType', { deep: !0 })
  private proTypeChange (val: any) {
    this.proTypeTemp = val
    if (!val) return
    const dictionaryType: any = {}
    for (let i = 0; i < val.length; i++) {
      const value = val[i]
      const item = value.split('-')
      if (item[1] === 'null' || item[1] === 'undefine') {
        this.proTypeTemp.splice(i, 1);
        (this.$refs.proType as any).$refs.panel.clearCheckedNodes()
        this.params.proType = this.proTypeTemp
      } else if (dictionaryType[item[1]] > 0) {
        this.proTypeTemp.splice(i, 1);
        (this.$refs.proType as any).$refs.panel.clearCheckedNodes()
        this.params.proType = this.proTypeTemp
      }
      dictionaryType[item[1]] = 1
    }
  }

  private async initData () {
    await getProxyType({}).then((res: any) => {
      if (res.code === 10000) {
        this.proTypeData = this.formatProTypeData([res.object.rpcOptions])
        console.log(res.object, this.proTypeData)
      }
    })
    await getProStree({}).then((res: any) => {
      if (res.code === 10000) {
        this.presenterIdData = this.formatPresenterData(res.object)
      }
    })
  }

  private formatPresenterData (list: any) {
    if (!list || list.length === 0) return []
    for (let i = 0; i < list.length; i++) {
      list[i].id = list[i].id + '-' + list[i].userName
      if (list[i].chirld) {
        list[i].chirld = list[i].chirld.length === 0 ? null : this.formatPresenterData(list[i].chirld)
      }
    }
    return list
  }

  private formatProTypeData (list: any) {
    if (!list || list.length === 0) return []
    for (let i = 0; i < list.length; i++) {
      list[i].optionKey = list[i].optionKey + '-' + list[i].businessId
      if (list[i].children) {
        list[i].children = list[i].children.length === 0 ? null : this.formatProTypeData(list[i].children)
      }
    }
    return list
  }

  private presenterIdChange (val: any) {
    this.params.proLevel = val.length + 1
  }

  private proLevelChange (val: any) {
    if (this.params.presenterId && val <= this.params.presenterId.length) {
      this.params.presenterId = []
    }
  }

  private validate (callback: Function) {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        callback()
      } else {
        this.$message.error('请正确填写数据')
        return false
      }
    })
  }

  beforeMount () {
    if (typeof (this.params.scanStatus) === 'string') {
      this.params.scanStatus = Number(this.params.scanStatus)
    }
    if (typeof (this.params.state) === 'string') {
      this.params.state = Number(this.params.state)
    }
    this.initData()
  }
}
